import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import BreadcrumbSchema from './components/feature/BreadcrumbSchema';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <BreadcrumbSchema />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
